import { createTypes } from 'redux-create-types';
import { fromType, } from 'kreighter';

const namespace = 'attachment';

export const attachmentActions = createTypes([
    'setStatusUploading',
    'setStatusError',
    'setStatusUploaded',
    'setStatusEmpty',
    'setUploadingProgress',
    'cleanUploadingProgress',
    'setFilePath'
], namespace)

export const attachmentActionsCreators = {
    setStatusUploading: fromType(attachmentActions.setStatusUploading, ['id']),
    setStatusError: fromType(attachmentActions.setStatusError, ['id']),
    setStatusUploaded: fromType(attachmentActions.setStatusUploaded, ['id']),
    setStatusEmpty: fromType(attachmentActions.setStatusEmpty, ['id']),
    setUploadingProgress: fromType(attachmentActions.setUploadingProgress, ['id', 'progress']),
    cleanUploadingProgress: fromType(attachmentActions.cleanUploadingProgress, ['id']),
    setFilePath: fromType(attachmentActions.setFilePath, ['id', 'filePath']),
}